export default {
  'camp67-navigation.the-camp': '캠프',
  'camp67-navigation.camp67': 'camp67',
  'camp67-navigation.camp67.who-are-we': '우리는 누구인가?',
  'camp67-navigation.camp67.camp67-&-kumbh': 'camp67 & Kumbh',
  'camp67-navigation.camp67.camp67-&-the-land': 'camp67 & 땅',
  'camp67-navigation.kumbh-2025': '막 메라 2026',
  'camp67-navigation.kumbh-2025.significance-of-kumbh': '쿰브의 중요성',
  'camp67-navigation.kumbh-2025.paush-purnima': '파우샤 푸르니마 (1월 3일)',
  'camp67-navigation.kumbh-2025.makar-sankranti': '마카르 산크란티 (1월 14일)',
  'camp67-navigation.kumbh-2025.mauni-amavasya': '마우니 아마바샤 (1월 18일)',
  'camp67-navigation.kumbh-2025.basant-panchami': '바산트 판차미 (1월 23일)',
  'camp67-navigation.kumbh-2025.maghi-purnima': '마기 푸르니마 (2월 1일)',
  'camp67-navigation.kumbh-2025.maha-shivratri': '마하 시브라트리 (2월 15일)',
  'camp67-navigation.packages': '패키지',
  'camp67-navigation.packages.reserve-a-room': '객실 예약',
  'camp67-navigation.packages.twin-room': '트윈 침대 코티지',
  'camp67-navigation.packages.family-room': '패밀리 코티지',
  'camp67-navigation.packages.family-room-plus': '패밀리 코티지 플러스',
  'camp67-navigation.packages.dormitory-single': '기숙사 (싱글)',
  'camp67-navigation.packages.dormitory-bunk': '기숙사 (벙크)',
  'camp67-navigation.contact-us': '문의하기',
  'camp67-banner.inquire-now': '관심 표현하기',
  'camp67-banner.book-now': '지금 예약하기',
  'camp67-header.tagline': '평화의 성스러운 모임.',
  'camp67-header.typewriter.prefix': '가장 ',
  'camp67-header.typewriter.serene': '고요한',
  'camp67-header.typewriter.peaceful': '평화로운',
  'camp67-header.typewriter.safe': '안전한',
  'camp67-header.typewriter.secure': '보안',
  'camp67-header.typewriter.hygienic': '위생적인',
  'camp67-header.typewriter.affordable': '저렴한',
  'camp67-header.typewriter.suffix.start': '캠프장의',
  'camp67-header.typewriter.suffix.end': '막 메라 2026.',
  'camp67-header.reserve-your-spot.prefix.desktop': '지금 예약하세요',
  'camp67-header.reserve-your-spot.prefix.mobile': '지금 예약하세요',
  'camp67-header.reserve-your-spot.secure-checkout': '다음과 함께 안전 결제:',
  'camp67-link.sukrit-wellness-tours': 'Sukrit Wellness Tours →',
  'camp67-link.kumbh-sukrit-camp': 'Kumbh Sukrit Camp →',
  'camp67-link.see-more-on': '더 보기',
  'camp67-link.learn-more': '더 알아보기',
  'camp67-link.terms-of-service': '서비스 약관',
  'camp67-link.privacy-policy': '개인정보 보호정책',
  'camp67-link.payment-policy': '결제 정책',
  'camp67-link.cancellation-policy': '취소 정책',
  'camp67.submit': '제출',
  'camp67.reset': '재설정',
  'camp67.continue': '결제 →',
  'camp67.go-back': '뒤로 가기',
  'camp67.ssl': 'SSL 및 브라우저 보안 정책을 통해 보안됩니다.',
  'camp67-one-of-a-kind.premium.prefix': '최고급 기숙사 및 개인 코티지 제공업체',
  'camp67-one-of-a-kind.team-behind': '팀에서',
  'camp67-one-of-a-kind.quality.hygienic.title': '위생적',
  'camp67-one-of-a-kind.quality.hygienic.image-alt':
    '세계적으로 유명한 Sanskriti 가수, 프랑스의 특별 게스트 Gabriella Burnel이 Gaushala 구내에 앉아 있습니다.',
  'camp67-one-of-a-kind.quality.hygienic.text':
    '국제 수준에서 편안함을 위해 높은 기준을 유지합니다.',
  'camp67-one-of-a-kind.quality.safe-and-secure.title': '안전하고 보안',
  'camp67-one-of-a-kind.quality.safe-and-secure.image-alt':
    'Kumbh Sukrit camp 2019의 높고 안전한 게이트.',
  'camp67-one-of-a-kind.quality.safe-and-secure.text':
    '곳곳의 유명인사와 공인들이 선택하는 숙소.',
  'camp67-one-of-a-kind.quality.peaceful.title': '평화로운',
  'camp67-one-of-a-kind.quality.peaceful.image-alt':
    '고목과 깨끗한 통로, 아름다운 환경을 갖춘 Kumbh Sukrit 캠프의 평화로운 숲 같은 울타리.',
  'camp67-one-of-a-kind.quality.peaceful.text':
    '리쉬들이 시간이 지나도 명상해온 <i>Sanskriti Vann</i>에 놓여 있습니다.',
  'camp67-one-of-a-kind.graphic.2013': '500+ 참석자, 10+ 국가',
  'camp67-one-of-a-kind.graphic.2019': '10,000 참석자, 26개국',
  'camp67-one-of-a-kind.graphic.2025.description': '지금까지 예약됨',
  'camp67-one-of-a-kind.graphic.2025.book-now': '지금 예약!',
  'camp67-one-of-a-kind.calendar.paush-purnima.date': '2026년 1월 3일',
  'camp67-one-of-a-kind.calendar.paush-purnima.title': 'Pausha Purnima',
  'camp67-one-of-a-kind.calendar.paush-purnima.description':
    'Magh Mela의 시작을 알리는 첫 번째 주요 목욕일입니다.',
  'camp67-one-of-a-kind.calendar.makar-sankranti.date': '2026년 1월 14일',
  'camp67-one-of-a-kind.calendar.makar-sankranti.title': 'Makar Sankranti',
  'camp67-one-of-a-kind.calendar.makar-sankranti.description':
    '가장 길한 날 중 하나로, 태양이 염소자리에 들어갑니다.',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.date': '2026년 1월 18일',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.title': 'Mauni Amavasya',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.description':
    '"스난의 왕"으로 불리며, 신자들은 침묵을 지키고 성스러운 물에 몸을 담급니다.',
  'camp67-one-of-a-kind.calendar.basant-panchami.date': '2026년 1월 23일',
  'camp67-one-of-a-kind.calendar.basant-panchami.title': '바산트 판차미',
  'camp67-one-of-a-kind.calendar.basant-panchami.description':
    '봄의 도래를 알리는 날로, 여신 사라스와티에게 봉헌됩니다.',
  'camp67-one-of-a-kind.calendar.maghi-purnima.date': '2026년 2월 1일',
  'camp67-one-of-a-kind.calendar.maghi-purnima.title': 'Maghi Purnima',
  'camp67-one-of-a-kind.calendar.maghi-purnima.description':
    '고행을 마무리하는 칼프와시들을 위한 중요한 스난의 날입니다.',
  'camp67-one-of-a-kind.calendar.maha-shivratri.date': '2026년 2월 15일',
  'camp67-one-of-a-kind.calendar.maha-shivratri.title': 'Maha Shivratri',
  'camp67-one-of-a-kind.calendar.maha-shivratri.description':
    '마그 멜라의 마지막 날로, 시바 신에게 봉헌됩니다.',
  'camp67-we-love-kumbh.decade-old': '10년 된 이야기',
  'camp67-we-love-kumbh.we-know-and': '우리는 알고 있으며',
  'camp67-we-love-kumbh.love': '사랑합니다',
  'camp67-we-love-kumbh.rto-kumbh-hosts':
    '등록된 여행사로서 Incredible India와 함께 우리는 10년 이상 Kumbh를 주최했습니다.',
  'camp67-we-love-kumbh.moments-kumbh-2019': '쿰브 2019의 순간들',
  'camp67-we-love-kumbh.hear-from-visitors': '국제 방문객들의 이야기',
  'camp67-we-love-kumbh.richard-testimonial.location': '뉴욕, 미국',
  'camp67-we-love-kumbh.richard-testimonial.image-alt':
    '2019년 우리 캠프사이트에서 뉴욕의 Richard Singh.',
  'camp67-we-love-kumbh.richard-testimonial.quote':
    '캠프가 환상적입니다. 직원들이 정말 놀랍고 친절했습니다. 여기서 모두가 내 친구가 되었습니다.',
  'camp67-we-love-kumbh.rajesh-testimonial.location': '볼보 구매 부사장',
  'camp67-we-love-kumbh.rajesh-testimonial.image-alt':
    '2019년 우리 캠프사이트에서 볼보의 구매 부사장 Rajesh Mittal.',
  'camp67-we-love-kumbh.rajesh-testimonial.quote':
    '너무나 평화롭고 신성한 경험이었습니다. 우리는 정말 즐겁게 지냈고 다시 오고 싶습니다.',
  'camp67-we-love-kumbh.gabriella-testimonial.location':
    '산스크리트 학자, @gaieasanskrit',
  'camp67-we-love-kumbh.gabriella-testimonial.image-alt':
    '2019년 우리 캠프사이트에서 산스크리트 학자 Gabriella Burnel.',
  'camp67-we-love-kumbh.gabriella-testimonial.quote':
    '이곳에서 배운 한 가지: 바랄 필요가 없습니다. 자연스럽게 일어날 것입니다.',
  'camp67-we-love-kumbh.pawars-testimonial.location': '마이크로소프트 & Edukinect',
  'camp67-we-love-kumbh.pawars-testimonial.image-alt':
    '2019년 우리 캠프사이트에서 마이크로소프트와 Edukinect의 Amit 및 Swapna Pawar.',
  'camp67-we-love-kumbh.pawars-testimonial.quote':
    '매우 아름답고 매우 편안합니다. 서비스가 정말 좋았습니다.',
  'camp67-our-location.ganges-banks': '갠지스 강변에',
  'camp67-our-location.lay-tents':
    '67개의 텐트가 <br className="hidden sm:block" /> 강하고 빛나며 서 있습니다',
  'camp67-our-location.ganges-banks-location':
    '갠지스 강변에 바로 위치해 있어 어떤 쿰브 행사도 놓치지 않으며, 혼잡함에서 벗어난 개인 구역를 가질 수 있습니다.',
  'camp67-accommodation.twin-room.title': '트윈 침대 코티지',
  'camp67-accommodation.twin-room.image-alt':
    '두 개의 싱글 침대와 편안한 좌석이 있는 방.',
  'camp67-accommodation.twin-room.subtitle': '2인용.',
  'camp67-accommodation.twin-room.description':
    '싱글 침대 두 개가 있는 아늑한 코티지입니다. 커플, 친구 또는 형제자매에게 완벽합니다.',
  'camp67-accommodation.twin-room.guests': '2 명',
  'camp67-accommodation.family-room.title': '패밀리 코티지',
  'camp67-accommodation.family-room.image-alt':
    '여왕 침대와 붙어있는 벙커 침대 및 별도의 싱글 침대가 있는 넓은 더블 룸.',
  'camp67-accommodation.family-room.subtitle': '4인 가족을 위한.',
  'camp67-accommodation.family-room.description':
    '퀸 침대에 2층 침대가 연결되어 있고 싱글 침대 1개가 있는 넓은 코티지입니다. 소규모 가족에게 이상적입니다.',
  'camp67-accommodation.family-room.guests': '4 명',
  'camp67-accommodation.family-room-plus.title': '패밀리 코티지 플러스',
  'camp67-accommodation.family-room-plus.image-alt':
    '여왕 침대와 붙어있는 벙커 침대 및 별도의 벙커 침대가 있는 넓은 더블 룸.',
  'camp67-accommodation.family-room-plus.subtitle': '6인 가족을 위한.',
  'camp67-accommodation.family-room-plus.description':
    '퀸 침대 두 개에 각각 벙커 침대가 붙어있는 큰 스위트룸. 대가족에게 가장 좋습니다.',
  'camp67-accommodation.family-room-plus.guests': '6 명',
  'camp67-accommodation.dorm-single.title': '기숙사 (싱글)',
  'camp67-accommodation.dorm-single.image-alt':
    '저렴하고 편안한 싱글 침대 기숙사 방. 실제 시설에는 벽이 없습니다.',
  'camp67-accommodation.dorm-single.subtitle': '하나를 위한, 기숙사 스타일.',
  'camp67-accommodation.dorm-single.description':
    '큰 기숙사에서 8개의 다른 싱글 침대 중 1개의 싱글 침대가 있는 공용 스위트룸.',
  'camp67-accommodation.dorm-single.guests': '8명',
  'camp67-accommodation.dorm-bunk.title': '기숙사 (벙커)',
  'camp67-accommodation.dorm-bunk.image-alt':
    '저렴하고 편안한 벙커 침대 기숙사 방. 실제 시설에는 벽이 없습니다.',
  'camp67-accommodation.dorm-bunk.subtitle': '1인용으로, 기숙사(벙크) 스타일입니다.',
  'camp67-accommodation.dorm-bunk.description':
    '큰 기숙사에서 8개의 다른 벙커 침대 중 1개의 벙커 침대가 있는 공용 스위트룸.',
  'camp67-accommodation.dorm-bunk.guests': '8명',
  'camp67-accommodation.price-per-guest': '/ 박',
  'camp67-accommodation.price-meals-included': '식사 포함',
  'camp67-accommodation.price-bathing-dates': '목욕 날짜에',
  'camp67-accommodation.view-next': '다음 보기 >',
  'camp67-accommodation.choose-accommodation': '숙소 선택',
  'camp67-accommodation.call-to-learn-more':
    '자세한 내용을 알아보려면 +91 84858 35675로 전화하거나 WhatsApp을 보내세요.',
  'camp67-accommodation-and-amenities.amenities-included': '모든 편의시설 포함',
  'camp67-accommodation-and-amenities.come-to-home':
    '집을 떠나도 <home-highlight>집</home-highlight>처럼 편안한 곳으로<br />오세요',
  'camp67-accommodation-and-amenities.choose-from-packages':
    '솔로, 커플, 가족, 소규모 및 대규모 그룹에 적합한 숙박 패키지 중에서 선택하세요.',
  'camp67-accommodation-and-amenities.luxurious-title': '호화로운 텐트',
  'camp67-accommodation-and-amenities.luxurious-detail':
    '2, 3, 4 또는 6인을 위한 디럭스 코티지 텐트, 또는 싱글 및 2층 침대가 있는 텐트 기숙사.',
  'camp67-accommodation-and-amenities.all-in-one-city-title': '올인원 텐트 시티',
  'camp67-accommodation-and-amenities.all-in-one-city-detail':
    '각 개인 코티지 혹은 기숙사 공용 구역, 훈련된 직원의 24/7 서비스, 그리고 중심 카페.',
  'camp67-accommodation-and-amenities.heater-services-title': '난방 서비스',
  'camp67-accommodation-and-amenities.heater-services-detail':
    '외부 온도에 관계없이 따뜻하고 편안한 환경을 보장하는 난방 솔루션 제공.',
  'camp67-accommodation-and-amenities.cafe-central-title': '24/7 카페 센트럴',
  'camp67-accommodation-and-amenities.cafe-central-detail':
    '커피, 차, 그리고 음식 옵션을 제공하는 24시간 카페.',
  'camp67-accommodation-and-amenities.daily-housekeeping-title': '일일 하우스키핑',
  'camp67-accommodation-and-amenities.daily-housekeeping-detail':
    '청소 서비스를 매일 제공하여 공간을 깨끗하고 매력적으로 유지해드리며, 세심한 부분에도 주의합니다.',
  'camp67-accommodation-and-amenities.bottled-water-title': '생수',
  'camp67-accommodation-and-amenities.bottled-water-detail':
    '무료 프리미엄 생수, 매일 새롭게 제공되어 편안하고 충분한 수분을 유지할 수 있습니다.',
  'camp67-accommodation-and-amenities.natural-gardens-title': '영적 체험',
  'camp67-accommodation-and-amenities.natural-gardens-detail':
    '캠프에서 야그야샬라, 명상, 요가 등 다양한 영적 체험을 이용하실 수 있습니다.',
  'camp67-accommodation-and-amenities.ayurvedic-products-title': '아유르베딕 제품',
  'camp67-accommodation-and-amenities.ayurvedic-products-detail':
    '웰니스와 재충전을 위해 제공되는, 자연 유래 아유르베다 스킨케어 제품의 특별 라인업을 이용하실 수 있습니다.',
  'camp67-accommodation-and-amenities.minutes-from-ganges-title':
    '갠지스 강에서 몇 분 거리',
  'camp67-accommodation-and-amenities.minutes-from-ganges-detail':
    '신성한 갠지스 강에서 도보로 단 5분 거리에 위치해 있어 조용한 물과 주변 지역에 쉽게 접근할 수 있습니다.',
  'camp67-accommodation-and-amenities.yoga-and-meditation-title': '요가 및 명상 세션',
  'camp67-accommodation-and-amenities.yoga-and-meditation-detail':
    '고대 인도 관행에 참여하세요. 숙박 패키지 가격에 포함되어 있습니다.',
  'camp67-tent-amenity.comfortable-living': '편안한 생활',
  'camp67-tent-amenity.comfortable-living.single-beds':
    '싱글 침대 세트 또는 이층 침대 중에서 선택',
  'camp67-tent-amenity.comfortable-living.single-bed': '싱글 침대',
  'camp67-tent-amenity.comfortable-living.bunk-bed': '이층 침대',
  'camp67-tent-amenity.comfortable-living.queen-bed':
    '퀸 침대와 이층 침대, 별도의 싱글 침대',
  'camp67-tent-amenity.comfortable-living.two-queen-beds':
    '퀸침대와 이층 침대가 있는 두 개의 침대',
  'camp67-tent-amenity.comfortable-living.quilt-blanket-pillows': '담요와 베개',
  'camp67-tent-amenity.comfortable-living.side-table-per-bed': '침대 옆 테이블',
  'camp67-tent-amenity.comfortable-living.centre-table': '중앙 테이블',
  'camp67-tent-amenity.comfortable-living.sofa-chairs': '소파 의자 2개',
  'camp67-tent-amenity.comfortable-living.side-table-kettle':
    '뜨거운 물 주전자와 일회용 컵이 있는 침대 옆 테이블',
  'camp67-tent-amenity.comfortable-living.table-lamp': '테이블 램프',
  'camp67-tent-amenity.toiletries': '세면도구',
  'camp67-tent-amenity.toiletries.shared-toilets-twin':
    '7개의 다른 방과 공유하는 화장실 및 욕실',
  'camp67-tent-amenity.toiletries.shared-toilets-dorm':
    '기숙사 전체가 사용하는 화장실 및 욕실',
  'camp67-tent-amenity.toiletries.shared-toilets-family':
    '3개의 다른 가족과 공유하는 화장실 및 욕실',
  'camp67-tent-amenity.toiletries.bath-towel': '감차 (얇은 면 수건)',
  'camp67-tent-amenity.toiletries.sukrit-soaps-lotion':
    '무료 Sukrit Ayurveda 비누와 로션',
  'camp67-tent-amenity.toiletries.small-dustbin': '작은 쓰레기통',
  'camp67-tent-amenity.power-storage': '전력 및 저장',
  'camp67-tent-amenity.power-storage.electric-power-point': '전원 콘센트',
  'camp67-tent-amenity.power-storage.electric-power-point-2x':
    '2개의 다중 슬롯이 있는 전기 콘센트',
  'camp67-tent-amenity.power-storage.electric-power-point-4-sets':
    '4세트의 다중 슬롯이 있는 전기 콘센트 (구역별로 2세트)',
  'camp67-tent-amenity.power-storage.luggage-storage-racks': '수하물 보관 선반',
  'camp67-tent-amenity.food-beverage': '음식 및 음료',
  'camp67-tent-amenity.food-beverage.drinking-water': '음료수 병 (1인당 500ml 1병)',
  'camp67-tent-amenity.food-beverage.tea-biscuits': '구매 가능한 차, 비스킷',
  'camp67-tent-amenity.food-beverage.lemongrass-tea-biscuits':
    'Sukrit 레몬그라스 차 & 비스킷',
  'camp67-tent-amenity.food-beverage.complimentary-meals':
    '<strong>무료</strong> 아침, 점심 및 저녁 식사 (식당 홀에서 뷔페로 제공)',
  'camp67-tent-amenity.complimentary': '무료',
  'camp67-tent-amenity.complimentary.souvenir':
    '기념품 - camp67 브랜딩이 있는 야구 모자, 1인당 1개',
  'camp67-faq.private-suites': '개인 스위트를 제공하나요?',
  'camp67-faq.private-suites.answer':
    '<p>네!</p><paragraph>저희는 camp67에서 3가지 개인 코티지 옵션을 제공합니다 - <twin-room-link>트윈 침대 코티지</twin-room-link>, <family-room-link>패밀리 코티지</family-room-link>, 또는 <family-room-plus-link>패밀리 코티지 플러스</family-room-plus-link> 옵션 (2, 4, 6 인원). 나머지 2개의 옵션은 더 큰 텐트 기숙사의 일부로, 싱글 또는 이층 침대입니다.</paragraph><paragraph>더 많은 질문이 있으시면 오른쪽의 문의 양식을 통해 문의해 주세요. 더 외진, 개인 공간에 머물고 싶으신 경우에는, <kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link>의 다른 서비스와 연결해 드릴 수 있습니다.</paragraph>',
  'camp67-faq.camp-start': '캠프는 언제 시작하나요?',
  'camp67-faq.camp-start.answer':
    '<p>우리는 1월 11일부터 예약을 받을 예정입니다. 이 날짜보다 일찍 시작할 계획이 있을 경우 알려드리겠습니다. 이러한 업데이트를 받으려면 <camp-start-link>아래에서 구독하세요</camp-start-link>.</p>',
  'camp67-faq.international-travel': '국제 여행객들에게 적합합니까?',
  'camp67-faq.tours-packages': '투어와 패키지를 제공하나요?',
  'camp67-faq.kumbh-sukrit': 'Kumbh Sukrit Camp와의 관계는 무엇인가요?',
  'camp67-faq.all-day-facilities': '종일 이용 가능한 시설이 있나요?',
  'camp67-faq.international-travel.answer':
    '<p>네! <international-travel-link>위에</international-travel-link> 언급된 것처럼 2019년 Kumbh 에디션에서 26개국의 여행객을 호스팅했습니다. 항공편 예약, 인도 도착 시 교통편, 현지 투어 등은 모두 준비되어 있습니다.</p> <paragraph>문의 사항이 있으면 이메일, WhatsApp, 또는 아래 라이브 채팅을 통해 연락 주십시오. 오른쪽의 문의 양식도 좋은 시작점입니다!</paragraph>',
  'camp67-faq.tours-packages.answer':
    '네, 제공합니다! 오른쪽 문의 양식 또는 제공된 이메일, 전화번호, WhatsApp, 라이브 채팅을 통해 연락주세요. 요구사항을 이해하여 가장 효과적으로 맞춤 제공하겠습니다.',
  'camp67-faq.kumbh-sukrit.answer':
    '<p><kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link>와 camp67은 <swt-link>Sukrit Wellness Tours</swt-link>의 이름 아래 운영됩니다. 간단히 말해서: 우리는 변혁적인 웰니스 경험을 제공하기 위해 세 가지 벤처 모두에서 결합된 팀입니다. 우리는 10년 이상 인도에서 운영 중이며 다양한 체류 및 투어를 제공하고 있습니다.</p> <paragraph>camp67은 우리 팀에서 새롭게 선보이는 브랜드이지만, <kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link>의 이전 에디션과 많은 특성을 공유하고 있습니다. 이전에 저희와 함께 하셨다면 익숙함과 새로움의 조화로움을 사랑하실 것이라고 확신합니다.</paragraph>',
  'camp67-faq.all-day-facilities.answer':
    '네! 우리 Kumbh 캠프 사이트를 호스트하는 장소는 Kumbh 외의 기간에도 관리되므로 종일 이용 가능한 시설을 갖추고 있습니다. 특정 시설에 관심이 있으시면 알려주세요.',
  'camp67-get-in-touch.success-thankyou': '감사합니다.',
  'camp67-get-in-touch.success-message': '귀하의 요청을 받았으며 곧 답변 드리겠습니다!',
  'camp67-get-in-touch': '문의하기',
  'camp67-get-in-touch.12-hours':
    'Magh Mela 2026에 관심이 있습니까? 저희가 도와드리겠습니다! 지금 문의하시면 12시간 내에 연락드리겠습니다.',
  'camp67-get-in-touch.placeholder-name': '이름을 입력하세요...',
  'camp67-get-in-touch.error-name': '이름을 입력해 주세요',
  'camp67-get-in-touch.placeholder-phone': '전화번호를 입력하세요...',
  'camp67-get-in-touch.error-phone': '유효한 전화번호를 입력하세요',
  'camp67-get-in-touch.placeholder-email': '이메일을 입력하세요...',
  'camp67-get-in-touch.error-email': '유효한 이메일을 입력하세요',
  'camp67-get-in-touch.placeholder-inquiry': '문의 내용을 입력하세요...',
  'camp67-get-in-touch.error-inquiry': '문의 내용을 입력해 주세요',
  'camp67-experience-kumbh.the-kumbh': 'Magh Mela',
  'camp67-experience-kumbh.engage-unique-experience':
    '마그 멜라의 가장 <unique-highlight>특별한</unique-highlight><br />체험에 함께하세요.',
  'camp67-experience-kumbh.sadhus':
    '나가 사두와의 교류부터 인류와 문화의 가장 큰 집회에 참여하기까지, Magh Mela를 경험하세요.',
  'camp67-experience-kumbh.sound.mobile': 'Magh Mela의 소리',
  'camp67-experience-kumbh.play-sound': '마그 멜라의 소리를 들어보세요',
  'camp67-experience-kumbh.pause-sound': '마그 멜라의 소리를 일시 정지하세요',
  'camp67-experience-kumbh.naga-sadhu.image-alt': '쿰브 멜라에서 Nāga Sadhu.',
  'camp67-experience-kumbh.naga-sadhu-orange.image-alt':
    '주황색 옷을 입은 쿰브 멜라의 Nāga Sadhu.',
  'camp67-experience-kumbh.naga-sadhu-beard.image-alt':
    '긴 수염을 가진 쿰브 멜라의 Nāga Sadhu.',
  'camp67-experience-kumbh.canoe.image-alt': '갠지스강 한가운데에서 카누를 젓는 남자.',
  'camp67-join-now.book-now': '~ 지금 예약하기 ~',
  'camp67-join-now.interested-in-kumbh':
    '마그 멜라 <br className="hidden sm:block" /> 2026에 관심이 있으신가요? <join-us-text>가입하세요</join-us-text>',
  'camp67-join-now.book-now-lowest-price':
    '<strong>우리와 함께 방을 예약하세요 →</strong><br />최저가부터',
  'camp67-join-now.chat-with-us':
    '<strong>우리에게 채팅하세요 →</strong><br />무엇이든 물어보세요',
  'camp67-footer.stay-informed':
    '<strong>정보를 받아보세요.</strong> 할인 및 판매 정보를 알려드립니다. 스팸 없음!',
  'camp67-footer.email.placeholder-subtle': '당신의 이메일...',
  'camp67-footer.email.placeholder':
    '여기에 이메일 주소를 입력하세요. 예: ilovecamp67@gmail.com...',
  'camp67-footer.subscribe-for-updates': '업데이트 구독',
  'camp67-footer.camp67-summary':
    '<swt-link>Sukrit Wellness Tours</swt-link>의 일부인 camp67은 <ksc-link>Kumbh Sukrit Camp</ksc-link> 팀에서 진행합니다. 관광부와 Incredible India와 제휴하여 10년 넘게 Kumbh를 호스팅해 왔습니다. <join-us-link>2026년에 합류하세요</join-us-link>.',
  'camp67-footer.a-product-of': '의 제품',
  'camp67-footer.subscribe-success': '구독되었습니다!',
  'camp67-footer.subscribe-success-message':
    '최신 업데이트 및 뉴스를 구독해 주셔서 감사합니다. 앞으로도 기대해 주세요!',
  'camp67-footer.subscribe-opt-out': '이 구독에서 언제든지 옵트아웃할 수 있습니다.',
  'camp67-content-page.read-more': '더 읽기',
  'camp67-content-page.child.reading-time': '분 독서 시간',
  'camp67-packages-page.subtitle': '다양한 숙박 옵션 중 선택하세요.',
  'camp67-packages-page.hero-image-alt':
    '갠지스 강에 떠 있는 보트와 함께 바라나시의 항구에서 본 일몰 광경.',
  'camp67-packages-page.summary':
    '우리가 제공하는 숙박 시설에 대해 더 알아보고 지금 예약하세요!',
  'camp67-packages-page-children.summary':
    'camp67에서 제공하는 숙박 옵션을 둘러보고 자리를 확보하세요!',
  'camp67-tent-page.twin-room-summary':
    '<p>\n  트윈 룸은 커플, 친구, 형제자매에게 가장 적합합니다. 편안하고 프라이빗한 텐트룸으로 마그 멜라 그라운드로의 일상 여행을 떠나며 완벽한 숙박을 제공해드립니다.\n</p>\n<paragraph>camp67 카페에서 커피 한 잔을 손에 들고 자리에 앉아보세요. 그날 관찰한 것을 서로 이야기하고 다음을 계획하세요!</paragraph>',
  'camp67-tent-page.family-room-summary':
    '<p>\n가족으로서 여행하는 가장 즐거운 부분은 함께 경험하는 것입니다.\ncamp67 패밀리 코티지에서 이를 신중하게 고려했습니다. 붙어 있는\n이층침대와 여유로운 공간이 있는 싱글 침대와 퀸 침대를 기다리고 있습니다.\n</p>\n<paragraph>침대를 정하는 것이 늘 그렇듯이 연습이 될 수 있지만, 그 필요한\n장애를 극복하고 나면 집에서처럼 느껴지리라고 확신합니다.</paragraph>',
  'camp67-tent-page.family-room-plus-summary':
    '<p>\n패밀리 코티지에서 침대를 고르는 게 까다로웠다면, 패밀리 코티지\n플러스로 들어가 보십시오... 두 개의 퀸 침대와 붙어 있는 이층침대가\n구비된 이 방은 6명이 들어갈 수 있는 가족 및 모임에 완벽하며,\n자신만의 스위트룸도 있습니다.\n</p>\n<paragraph>서로와 함께하는 질 높은 가족 시간을 공유하세요. 걱정 마세요 -\n짐은 안전하고, 커피는 항상 따뜻하고 여러분을 기다리고 있습니다.\n</paragraph>',
  'camp67-tent-page.dorm-single-summary':
    "<p>\n솔로 여행객, 블로거 또는 디지털 노마드를 만나고 싶으신가요? 기숙사 방은 당신을 위해 만들어졌습니다. 전형적인 여행 호스텔 환경에서 다른 사람들과 함께 하세요. 방에 8개의 침대가 있어, 솔로 여행객이 일반적으로 익숙한 '공간 좀 줘'와 '대화하고 싶어' 사이의 섬세한 균형을 이룹니다.\n</p>",
  'camp67-tent-page.dorm-bunk-summary':
    '<p>\n더 전통적인 솔로 여행객 경험을 찾고 계신가요? 저희의 더 큰 기숙사 방에서 침대를 잡으세요! 이 방은 16명을 수용할 수 있으며 밤새도록 귀신 이야기를 해줄 사람을 만날 수 있는 훌륭한 장소입니다.\n</p>\n<paragraph>그룹으로 여행 중이라면, 이 옵션이 특히 흥미로울 수 있습니다. 그렇다면 알려주세요, 저희가 정리해 드리겠습니다.</paragraph>',
  'camp67-tent-page.back-to-packages': '모든 패키지로 돌아가기',
  'camp67-tent-page.book-tent-now': '지금 이 방 예약하기!',
  'camp67-who-we-are.subtitle': 'camp67의 정신.',
  'camp67-who-we-are.hero-image-alt':
    '갠지스 강에 떠 있는 보트와 함께 바라나시의 항구에서 본 일몰 광경.',
  'camp67-who-we-are.summary':
    'Kumbh Sukrit 팀에서 제공하는 camp67: Magh Mela 2026에서 가장 저렴하고 고요하며 평화로운 제안입니다.',
  'camp67-who-we-are.content':
    '\n  <p>\n        한 문장으로: <strong>camp67</strong>은 마그 멜라 전통에 대한 공예, 문화 전통, 존경의 노동입니다.\n      </p>\n      <paragraph>\n        우리는 다양한 직업적 및 개인적 배경을 가진 다양성 그룹입니다.\n        업적과 역할을 제쳐두고 전 세계 수백만 명의 순례자가\n        6년마다 참가하는 이 위대한 모험을 축하합니다. 우리에게 마그 멜라는 변화의 관문입니다.\n      </paragraph>\n      <paragraph>\n        camp67은 누구나 환영하는 Magh Mela 캠프사이트에 대한 우리의 비전입니다.\n        \'모두\'라는 부분은 우리에게 가장 중요합니다. Kumbh의 정신과 기본 원칙은 "인간"입니다.\n      </paragraph>\n      <paragraph>\n        camp67에서는 전 세계에서 인생의 모험을 하는 사람들을 만나게 될 뿐만 아니라\n        24시간 카페에서그들과 앉아 인생 이야기를 나눌 수 있습니다. 블로거와 여행객을 만나게 될 것이며,\n        Prayag Raj에서 최고의 길거리 음식을 어디서 찾을 수 있는지 알려줄 것입니다. 우리의 팀과 만나게 되며,\n        그들은 제복을 입고 있을지라도 당신과 앉아\n        <the-land-link>camp67의 땅</the-land-link>\n        의 이야기를 전해줄 것이며, 그 고유함에 놀라움을 금치 못할 것입니다.\n      </paragraph>\n      <paragraph>\n        왜 우리가 여러분이 참가하기를 기대하는지요? 우리는 여러분이 이곳을 좋아하실 것이며, 다시 돌아오고 싶어하실 것이라고 믿기 때문입니다.\n      </paragraph>\n      <paragraph>\n        우리를 믿으세요,\n        <camp67-kumbh-link>우리는 전에 해봤습니다</camp67-kumbh-link>: 2019 Kumbh Mela에서 Kumbh Sukrit로서.\n      </paragraph>\n      <paragraph>\n        Kumbh Sukrit은 10년 이상 동안 Kumbh에 참여했습니다. 전 세계 25개국에서 10,000명 이상의 손님을 수용한 바 있습니다. 우리는 고대 인도의 전통과 고품질 서비스에 열정을 가진 다양한 산업의 전문가들로 구성된 팀입니다.\n      </paragraph>\n      <paragraph>\n        지난 10년 동안, 이것은 우리를 Kumbh Mela의 놀라운 유산과 독특함을 가로지르는 여행으로 데려갔습니다.\n        2019년에는 손님들을 전세계에서 모셔와 유명한 “Sanskriti Vann”에 위치한 텐트 마을에서 호스팅했습니다. 이곳은 고대 리쉬와 요기들이 수년, 수십 년 동안 명상했던 곳입니다.\n      </paragraph>\n      <paragraph>\n        이러한 모든 경험과 함께, 우리는 camp67을 소개하고 Magh Mela의 평생 잊지 못할 경험을 제공드리고자 합니다.\n      </paragraph>\n      <p>\n         우리는 어디에 위치하고 있는지 보려면 <maps-link>구글 지도에서 우리를 찾아보세요</maps-link>. 우리는 Daraganj, Prayagraj의 Sangam Ghat 근처에 있습니다!\n      </p>\n      ',
  'camp67-who-we-are-summary':
    'Kumbh Sukrit 팀에서 제공하는 camp67: Magh Mela 2026에서 가장 저렴하고 고요하며 평화로운 제안입니다.',
  'camp67-and-kumbh.subtitle': '왜 우리는 Magh Mela를 소중히 여길까요?',
  'camp67-and-kumbh.hero-image-alt': '갠지스강에 있는 보트와 함께 바라나시 항구의 석양.',
  'camp67-and-kumbh.summary':
    '왜 마그 멜라? 모든 축제와 행사 중에 왜 마그 멜라를 선택해야 할까요? 좋은 질문입니다 - 그 이유는 숨겨진 디테일에 있습니다…',
  'camp67-and-kumbh.content':
    '\n    <paragraph>\n      우리는 여러 해 전에 마그 멜라와 사랑에 빠졌습니다. 세계에서 이처럼 규모가 크고 독특한 행사는 매우 드물며, 인류 역사에서도 매우 드문 일입니다.\n    </paragraph>\n    <paragraph>\n      왜일까요? 어디에서 1억 4천만 명 이상이 같은 장소에 모여 각각의 희망과 꿈을 갖고 있는 모습을 볼 수 있을까요? 이는 진정한 대규모 행사이지만, 그 아름다움은 숫자에 있지 않고 현장에서 직접 보는 것에 있습니다.\n    </paragraph>\n    <paragraph>\n      시작하자면: 마그 멜라에 가면 Ganges 강가에 있는 수많은 소규모에서 중간 규모의 모임 장소들이 맞이할 것입니다 (camp67의 위치에서 걸어가기 쉬운 거리). Prayag Raj 시가 행사를 시작하기 전에 설치하는 텐트 도시들 사이에서, 그리고 그 외 여러 곳에서도 볼 수 있습니다. 이는 아침 산책을 완전히 변화시킵니다. 마그 멜라 현장을 거닐기 시작할 때는 한 가지 인상을 받고 끝날 때는 기대가 완전히 바뀌고 관점이 완전히 달라집니다.\n    </paragraph>\n    <paragraph>\n      이는 구체적으로 어떤 모습일까요? 인도의 전역에서 영적 지도자들이 대거 모입니다. 다양한 종류와 배경의 나가 사두(Naga Sadhus)들이 일반 대중에게 이야기를 통해 자신을 드러냅니다. 농촌 마을의 가족들이 삶에서 새로운 시작을 위한 축복을 받기 위해 이곳에 모입니다. 이야기와 경험은 수없이 많습니다.\n    </paragraph>\n    <paragraph>\n      한 가지 확실한 것은: 마그 멜라를 떠날 때 자신의 이야기를 가지고 갈 것이라는 점입니다.\n    </paragraph>\n  ',
  'camp67-and-the-land.subtitle': '인도의 고대 이야기.',
  'camp67-and-the-land.hero-image-alt':
    '갠지스강에 있는 보트와 함께 바라나시 항구의 석양.',
  'camp67-and-the-land.summary':
    'camp67이 위치한 땅은 더 이상은 명확하지 않은 역사에 둘러싸여 있습니다. 이곳은 세계에서 가장 독특한 위치 중 하나입니다.',
  'camp67-and-the-land.content':
    "\n    <paragraph>\n      camp67는 바로 Sanskriti Vann 옆에 위치해 있습니다. 문자 그대로 번역하면, Sanskriti Vann은 '신성한 숲'입니다. 수천 년 전에 이곳은 Rishis와 Maharishis가 중단 없이 명상을 하던 신성한 장소였습니다. 만약 모른다면, 이는 몇 달에서 몇 년, 몇 십 년 동안 다양할 수 있습니다. 이것이 인도의 Rishis의 독특한 점입니다. 또한, camp67이 있는 땅과 힌두신들의 왕, 전쟁과 비의 신인 Indra에 대한 전설 사이에 연관이 있습니다.\n    </paragraph>\n    <paragraph>\n      이곳에서 명상을 하던 많은 Rishis는 여전히 Sanskriti Vann에 있는 나무 밑에 앉아 있었습니다. 이 공간에 들어서면, 나무들은 당신 위에 솟아 있으며, 외부 세계의 소란에서 고대의 보호를 제공합니다.\n    </paragraph>\n    <paragraph>\n      상상해 보세요: 인도의 바쁜 거리에서 나와 캠프장으로 좌회전합니다. 그곳에 들어가면 외부 세계의 소리는 거의 들리지 않으며, 역사가 풍부한 장소에서 자연의 수호자에게 둘러싸여 있습니다. 이는 다른 어떤 곳에서도 경험하지 못한 고요함을 제공합니다. 2026년 마그 멜라 기간 동안 camp67ers는 이 독특한 숲에 독점적으로 접근할 수 있을 것입니다.\n    </paragraph>\n    <paragraph>\n      마지막으로: camp67에서 불과 10분 거리에 있는 백만 명의 사람들이 자신의 마그 멜라 여행을 준비하고 있다는 사실을 고려해보세요. 갑자기, 그 땅의 매력이 당신에게 다가오고, 그래서... 당신은 결국 마그 멜라 캠프를 짓고 모두가 함께 하도록 초대하게 됩니다!\n    </paragraph>\n    <paragraph>\n      이것이 대략 (그리고 사실 그대로의) camp67이 시작된 방식입니다. 땅이 먼저였습니다.\n    </paragraph>\n  ",
  'camp67-the-camp.subtitle': '저희에 대해 더 알아보세요!',
  'camp67-the-camp.hero-image-alt': '갠지스강에 있는 보트와 함께 바라나시 항구의 석양.',
  'camp67-the-camp.summary':
    'camp67이 존재하는 이유와 저희를 움직이는 원동력에 대해 알아보세요.',
  'significance-of-kumbh.subtitle': 'Kumbh의 이야기.',
  'significance-of-kumbh.hero-image-alt':
    '아수라들(왼쪽)과 데바들(오른쪽)이 우유의 바다를 젓고 있다.',
  'significance-of-kumbh.summary':
    "쿰브의 이야기는 상징적이면서도 문자 그대로입니다. 문자 그대로의 의미에서: 쿰브는 '항아리'를 의미합니다. 그것은 불사의 신성한 넥타를 담고 있는 항아리를 나타냅니다.",
  'significance-of-kumbh.content':
    "\n    <p>\n      우리는 힌두교 신들(데바스)과 악마들(라크샤사스) 사이의 오래된 전투를 인정하여 Kumbh를 축하합니다.\n    </p>\n    <paragraph>\n      이야기에 따르면, 수백 년 전, 힌두교 신들과 악마들은 불사의 영약(암리타)를 얻기 위해 우유의 바다(Kshirasagara)를 함께 막혔습니다. 이 과정에서 만다르 산을 쳐서 체를 만드는데, 뱀 바스키를 로프로 사용했습니다. 비슈누 신은 거북이의 모습으로 산을 지탱했습니다.\n    </paragraph>\n    <paragraph>\n      바다를 막아서, 신성함이 나타났습니다: 여기에서 힌두교 부의 신 여신 락슈미(부, 운, 다산, 힘, 아름다움, 번영의 신), 달, 예상했던 것처럼 항아리(쿰브)에 담긴 암리타가 나타났습니다. 그러나… 영약이 나타나자마자 악마들이 그것을 독차지하려고 했습니다. 악마들을 속이기 위해 힌두교 매혹의 여신 모히니의 모습으로 변신한 비슈누 신은 힌두교 신들 사이에 암리타를 분배했습니다.\n    </paragraph>\n    <paragraph>\n      악마들에게 쫓기면서, 힌두교 신들은 인도를 돌아다니며 이 영약을 마셨고, 불사의 영약의 방울이 인도의 여러 지역에 떨어졌습니다. 이 지역들이 바로 Haridwar, Prayag, Nashik, 및 Ujjain으로 Kumbh가 축하되는 네 곳입니다. 이로 인해 'Kumbh'의 기원이 설명됩니다.\n    </paragraph>\n    <paragraph>\n      더 상징적인 의미로, Kumbh는 인간의 몸을 나타내며, 그 안에 불사의 영약이 들어 있습니다. 오직 고대 Rishis와 현자들만이 이에 대해 말했습니다.\n    </paragraph>\n  ",
  'paush-purnima.subtitle': '차드라 경의 날',
  'paush-purnima.hero-image-alt': '구름에 둘러싸인 보름달의 야경.',
  'paush-purnima.summary': '달의 신 차드라 경을 기념하는 날',
  'paush-purnima.content':
    '\n    <p>\n      Paush Purnima는 힌두교 음력에 따라 파우쉬 월의 보름날을 기념합니다. 달과의 중요한 연관성을 가지고 있어 성스러운 목욕을 통해 정화, 재생, 신체 및 내면의 전체적인 정화를 위해 유리한 날로 여겨집니다.\n    </p>\n    <paragraph>\n      이 날은 힌두교 달의 신 차드라 신의 축복을 구하기에 가장 이상적인 날입니다. 신자들은 이날 특별한 단식을 관찰합니다.\n    </paragraph>\n  ',
  'mauni-amavasya.subtitle': '마그의 영광.',
  'mauni-amavasya.hero-image-alt':
    '방대한 갠지스 강에서 보트를 타고 있는 사람들의 햇볕이 약간 비치는 모습.',
  'mauni-amavasya.summary': '마그 멜라의 주요 목욕일; 수백만 명이 침묵과 성찰을 하는 날.',
  'mauni-amavasya.content':
    "\n    <p>\n      신월에 일어나는 이 날짜는 마그 멜라 동안 목욕하기에 가장 길조로운 날로 간주됩니다.\n      신자들은 마운 브라트(말을 하지 않고 전혀 말하지 않는 서원[인도 리쉬들에 의해 내면의\n      완전한 침묵으로 묘사됨])를 이 날에 관찰하며 그들의 영성을 침묵 속에서 성찰하고,\n      깊은 내적 이로움을 가져다준다고 믿는 의식을 수행합니다.\n    </p>\n    <paragraph>\n      '마우니'라는 문구는 문자 그대로 '침묵'으로 번역됩니다. 그것은 내면의 평화로움을\n      요구하는 영적 향상을 위한 여정의 필수적인 부분으로 간주됩니다.\n    </paragraph>\n  ",
  'makar-sankranti.subtitle': '계절의 전환',
  'makar-sankranti.hero-image-alt': '밝은 햇빛이 비추는 흰 꽃밭.',
  'makar-sankranti.summary':
    '힌두 달력에서 가장 길조한 날 중 하나. 계절의 전환과 새 시작.',
  'makar-sankranti.content':
    '\n    <p>\n      이 날은 태양이 황소자리(마카라)로 바뀌는 힌두교 달력에서 가장 길한 날 중 하나입니다. 이는 겨울의 끝과 더 긴 낮의 시작을 상징합니다. 이날은 신의 축복을 받기 위해 필요로 하는 사람들에게 자선을 베푸는 데 특히 유리한 날로 여겨지며, 성스러운 강 Ganges에서 목욕하는 것이 좋습니다.\n    </p>\n    <paragraph>\n      Makar Sankranti는 계절의 변화와 유사하게 인생과 자신을 새롭게 시작하고 재발견하기에 이상적인 시간으로 여겨집니다.\n    </paragraph>\n  ',
  'maha-shivratri.subtitle': '시바의 위대한 밤',
  'maha-shivratri.hero-image-alt': '파란 하늘을 배경으로 한 시바 신의 동상.',
  'maha-shivratri.summary':
    '마하 멜라가 끝나기 직전에 관찰되는 시바신에게 바쳐진 날입니다.',
  'maha-shivratri.content':
    '\n    <p>\n      마하 멜라가 끝나기 직전에 관찰되는 시바신에게 바쳐진 날입니다. 신도들은 시바신을 기리며 금식하고 성스러운 의식을 수행합니다.\n      이날 목욕은 시바신을 존경하는 것으로 여겨지며 신도들이 주님으로부터의 해방과 축복을 받고 그들의 삶에서 모든 어둠을 쫓아내는데 도움을 줍니다.\n    </p>\n    <paragraph>\n      이 날에는 특정한 만트라와 찬가가 낭송되고 불려집니다.\n    </paragraph>\n  ',
  'maghi-purnima.subtitle': '보름달의 날',
  'maghi-purnima.hero-image-alt':
    '파란 하늘을 배경으로 오렌지색 옷을 입은 노인의 실루엣.',
  'maghi-purnima.summary':
    '창조의 신 브라마와 쿰브 기간 동안 강가에서 사는 성인 공동체와 관련된 날.',
  'maghi-purnima.content':
    '\n    <p>\n      이 보름달은 힌두교 창조 신 브라흐마와 관련이 있습니다.\n    </p>\n    <paragraph>\n      이날 목욕은 모든 신들로부터 축복과 지지를 받는 것으로 믿어지며, 또한 전체 Kumbh 기간 동안 강가에 거주하며 모든 다른 편안함을 포기한 성직자 또는 Kalpvasis 공동체와 연관되어 있습니다.\n    </paragraph>\n  ',
  'basant-panchami.subtitle': '봄의 시작',
  'basant-panchami.hero-image-alt':
    '힌두 여신 사라스와티 - 지식과 예술의 여신. 라자 라비 바르마의 그림에서.',
  'basant-panchami.summary':
    "'봄의 도래를 축하하는 바산트 판차미는 지식과 예술의 힌두 여신 사라스와티'에게 바쳐집니다.",
  'basant-panchami.content':
    '\n    <p>\n      봄의 도래를 기념하여 Basant Panchami는 지식과 예술의 힌두교 여신 Saraswati에게 바칩니다. 신자들은 노란색 옷을 입고 여신 Saraswati에게 노란 꽃을 바칩니다. 인도의 교육 기관들은 여신에게 깊은 존경을 표하고, 특별 기도를 조직합니다.\n    </p>\n    <paragraph>\n      이 길한 날에 성스러운 목욕을 하면 지식과 지혜를 축복받습니다.\n    </paragraph>\n  ',
  'kumbh-2025.subtitle': 'Magh Mela 2026 여정을 시작하세요.',
  'kumbh-2025.hero-image-alt': '갠지스 강의 보트와 바라나시 항구의 일몰 모습.',
  'kumbh-2025.summary':
    'Magh Mela의 중요성과 이 성대한 축제 동안 일어나는 이벤트에 대해 더 알아보세요.',
  'camp67-reservation.book-with-us': '우리와 함께 여행을 예약하세요',
  'camp67-reservation.timeout.title': '예약을 확보하기 위해 10분 남았습니다.',
  'camp67-reservation.timeout.description':
    '예약 수요가 높아 더 이상 예약을 유지할 수 없음을 알려드립니다.',
  'camp67-reservation.timeout.ok': '좋아요',
  'camp67-reservation.form.step-1': '<strong>1단계/3:</strong> 텐트 경험 선택',
  'camp67-reservation.form.step-1.adult': '성인',
  'camp67-reservation.form.step-1.children': '어린이',
  'camp67-reservation.form.step-1.children-detail': '18세 미만',
  'camp67-reservation.form.step-2': '<strong>2단계/3:</strong> 날짜 선택',
  'camp67-reservation.form.step-2.tent-option.unavailable':
    '이 방은 선택한 날짜 동안 이용할 수 없습니다.',
  'camp67-reservation.form.step-2.tent-option.image-alt':
    'camp67의 {{type}} 제공에 따른 텐트 경험을 표시합니다.',
  'camp67-reservation.form.step-3': '<strong>3/3단계:</strong> 세부 정보를 입력하세요',
  'camp67-reservation.form.step-3.guests': '손님 목록*',
  'camp67-reservation.form.step-3.disclaimer':
    '모든 손님의 최소한의 세부 정보가 필요합니다. 자세한 내용은 <payment-policy-link>당사 정책</payment-policy-link>을 참조하십시오.',
  'camp67-reservation.form.step-3.additional-bed': '추가 침대',
  'camp67-reservation.form.step-3.guests.enter-name': '이름 입력...',
  'camp67-reservation.form.step-3.guests.enter-age': '나이 입력...',
  'camp67-reservation.form.step-3.gender-male': '남성',
  'camp67-reservation.form.step-3.gender-female': '여성',
  'camp67-reservation.form.step-3.gender-non-binary': '논바이너리',
  'camp67-reservation.form.step-3.gender-none': '없음',
  'camp67-reservation.form.step-3.gender-prefer-not-to-say': '답변을 선호하지 않음',
  'camp67-reservation.form.step-3.primary-contact': '주요 연락처*',
  'camp67-reservation.form.step-3.primary-contact.inform':
    '예약 업데이트를 위해 알릴 사람을 선택하세요. 모든 데이터는 <privacy-policy-link>안전하게 처리됩니다.</privacy-policy-link>',
  'camp67-reservation.form.step-3.primary-contact.select': '주요 연락처를 선택하세요',
  'camp67-reservation.form.step-3.primary-contact.email': '이메일 주소 입력...',
  'camp67-reservation.form.step-3.primary-contact.phone': '전화번호 입력...',
  'camp67-reservation.form.submit.bathing-added': '목욕 날짜에 추가됨.',
  'camp67-reservation.form.submit.bathing-charged': '목욕 날짜에 요금이 부과됨.',
  'camp67-reservation.form.submit.night': '밤',
  'camp67-reservation.form.submit.nights': '밤들',
  'camp67-reservation.form.submit.room': '방',
  'camp67-reservation.form.submit.rooms': '방들',
  'camp67-reservation.form.submit.empty': '세부 정보와 날짜를 먼저 입력하십시오.',
  'camp67-reservation.form.submit.total': '합계',
  'camp67-reservation.form.submit.price-shown-in': '표시된 가격',
  'camp67-reservation.form.submit.exchange-calculated': '환율은<br />매일 계산됩니다',
  'camp67-reservation.payment': '결제',
  'camp67-reservation.payment.tandc':
    '나는 <terms-of-service-radio>서비스 약관</terms-of-service-radio>에 동의합니다.',
  'camp67-reservation.payment.domestic-and-international': '인도 및 국제 고객용.',
  'camp67-reservation.payment.international': '국제 고객용.',
  'camp67-reservation.payment.provider-alt': '결제 제공자 로고',
  'camp67-reservation.payment.continue': '계속하여 결제 예약하기',
  'camp67-contact.contact-us': '문의하기',
  'camp67-contact.offered-by': 'camp67 제공',
  'camp67-contact.address': '본사 주소',
  'camp67-contact.questions': '질문이나 문의 사항이 있으면 언제든지 문의하십시오:',
  'camp67-contact.email': '이메일',
  'camp67-contact.phone': '전화',
  'camp67-contact.see-tos': '서비스 약관 보기',
  'camp67-ttent-amenity.power-storage.luggage-storage-racks': '수하물 저장 랙',
  'camp67-reservation.form.step-1.summary.dates': '숙박 날짜',
  'camp67-reservation.form.step-1.summary.guests': '투숙객',
  'camp67-reservation.form.step-2.summary.rooms': '선택한 객실',
  'camp67-reservation.form.step-2.summary.rooms.empty': '객실을 선택해 주세요',
  'camp67-reservation.form.step-3.summary.guests': '투숙객 상세 정보',
  'camp67-reservation.form.step-3.summary.guests.empty': '투숙객 정보를 입력해 주세요',
  'camp67-reservation.form.step-3.summary.primary': '주 연락처',
  'camp67-reservation.form.step-3.summary.primary.empty': '주 연락처를 제공해 주세요',
  'camp67-reservation.form.step-1.summary.dates.value': '까지',
  'camp67-reservation.form.step.disabled.tooltip': '먼저 이전 단계를 완료하십시오.',
  'camp67-reservation.form.step-1.summary.dates.empty-start': '시작 날짜를 선택해주세요',
  'camp67-reservation.form.step-1.summary.dates.empty-end': '종료 날짜를 선택해주세요',
  'camp67-reservation.form.step-1.summary.guests.empty': '투숙객 수를 선택해주세요',
  'camp67-snackbar.invalid-date-range': '선택한 날짜 범위가 유효하지 않습니다.',
  'camp67-snackbar.invalid-bathing-dates-range':
    '목욕 날짜를 포함한 예약은 최소 3일 2박이어야 합니다.',
  'camp67-reservation.form.step-1.next': '2단계로 이동',
  'camp67-reservation.form.step-2.next': '3단계로 이동',
  'camp67-reservation.form.step.next': '다음 단계',
  'camp67-reservation.form.step-1.next.tooltip.disabled': '먼저 객실을 선택하세요.',
  'camp67-reservation.form.step-2.summary.rooms.add.tooltip': '추가 1',
  'camp67-reservation.form.step-2.summary.rooms.subtract.tooltip': '제거 1',
  'camp67-reservation.form.step-2.next.tooltip.disabled': '먼저 날짜를 입력하세요.',
  'camp67-reservation.form.step-3.next.tooltip.disabled':
    '먼저 손님 및 연락처 정보를 입력하세요.',
  'camp67-reservation.form.step.expand': '단계 확장',
  'camp67-reservation.form.step.collapse': '단계 축소',
  'camp67-reservation.form.step-1.tent-option.unavailable':
    '이 객실은 선택한 날짜와 총 게스트 수 동안 이용할 수 없습니다.',
  'camp67-reservation.form.step-1.tent-option.image-alt':
    'camp67의 {{type}} 제공에 따른 텐트 경험을 표시합니다.',
  'camp67-reservation.form.step-1.room-viewer': '방 보기:',
  'camp67-reservation.form.step-1.room-gallery': '이미지 {{current}} / {{total}}',
  'camp67-reservation.form.step-1.summary.rooms': '선택한 객실',
  'camp67-reservation.form.step-1.summary.rooms.add.tooltip': '1개 추가',
  'camp67-reservation.form.step-1.summary.rooms.subtract.tooltip': '1개 빼기',
  'camp67-reservation.form.step-1.summary.rooms.empty': '객실을 선택해주세요',
  'camp67-reservation.form.step-2.adult': '성인',
  'camp67-reservation.form.step-2.children': '어린이',
  'camp67-reservation.form.step-2.children-detail': '18세 미만',
  'camp67-reservation.form.step-2.summary.dates': '숙박 날짜',
  'camp67-reservation.form.step-2.summary.dates.empty-start': '시작 날짜를 선택해주세요',
  'camp67-reservation.form.step-2.summary.dates.empty-end': '종료 날짜를 선택해주세요',
  'camp67-reservation.form.step-2.summary.dates.value': '에서',
  'camp67-reservation.form.step-2.summary.guests.empty': '게스트 수를 선택해주세요',
  'camp67-reservation.form.step-2.summary.guests': '게스트',
  'camp67-header.see-prices': '제공 항목 보기',
  'camp67-header.inquiry': '관심 표현하기',
  'camp67-snackbar.invalid-bathing-date-selected':
    '예약은 목욕 날짜에 시작하거나 종료할 수 없습니다.',
  'camp67-accommodation.price-bathroom-included': '개인 욕실 & 화장실',
  'camp67-accommodation-and-amenities.private.title':
    '디럭스 및 프라이빗 코티지 텐트 숙박 시설',
  'camp67-accommodation-and-amenities.dorm.title': '기숙사 텐트 숙소',
  'camp67-tent-amenity.toiletries.private-bathroom': '개인, 부착된 화장실 및 욕실 시설',
  'camp67-accommodation.price-shared-bathroom-included': '개인 욕실 & 화장실',
  'camp67-reservation.form.step-3.too-many-guests':
    '<strong>⚠️ 너무 많은 손님</strong><br/>객실을 추가하거나 투숙객 수를 <tentCapacityCode>{{totalTentCapacity}}</tentCapacityCode>로 줄이세요. 귀하의 객실은 총 <roomsCapacityCode>{{totalTentCapacity}} 침대(s)</roomsCapacityCode>를 제공합니다. 그러나 입력하신 투숙객 수는 <guestsCountCode>{{guestCount}} guests</guestsCountCode>입니다. 문제가 있으면 <bookingsCode>bookings@camp67.com</bookingsCode>으로 문의하세요.',
  'camp67-navigation.packages.premium-twin-room': '프리미엄 코티지',
  'camp67-navigation.packages.private-group-cottage': '프라이빗 그룹 코티지',
  'camp67-accommodation.premium-twin-room.title': '프리미엄 코티지',
  'camp67-accommodation.premium-twin-room.image-alt':
    '두 개의 싱글 침대, 수하물 선반, 의자 및 테이블이 있는 넓은 방.',
  'camp67-accommodation.premium-twin-room.subtitle': '2인용.',
  'camp67-accommodation.premium-twin-room.description':
    '싱글 침대 두 개가 있는 프리미엄 스위트룸입니다. 커플, 친구 또는 형제자매에게 적합합니다.',
  'camp67-accommodation.premium-twin-room.guests': '2명',
  'camp67-accommodation.private-group-cottage.title': '프라이빗 그룹 코티지',
  'camp67-accommodation.private-group-cottage.image-alt':
    '8명을 위한 경제적이고 편안한 싱글 침대 도미토리',
  'camp67-accommodation.private-group-cottage.subtitle': '그룹, 도미토리 스타일.',
  'camp67-accommodation.private-group-cottage.description':
    '8개의 싱글 침대와 부속 화장실 및 욕실이 있는 큰 개인용 코티지.',
  'camp67-accommodation.private-group-cottage.guests': '8명',
  'camp67-accommodation.price-per-guest-private': '/ 박',
  'camp67-tent-page.premium-twin-room-summary':
    '<p>\n  프리미엄 코티지는 커플, 친구 및 형제자매에게 가장 적합합니다. 편안하고 넓고 고급스러운 텐트-룸으로,\n  마그 멜라 광장으로의 일일 모험을 떠나고 돌아오는 동안 완벽한 숙박을 제공합니다.\n</p>\n<paragraph>camp67 카페에서 커피를 들고 자리에 앉기를 권장합니다. 하루 동안 관찰한 내용을 서로 이야기하고 다음 날을 계획하세요!</paragraph>',
  'camp67-tent-page.private-group-cottage-summary':
    "<p>\n혼자 여행하는 여행자, 블로거 또는 디지털 노마드를 위한\n도미토리 룸입니다. 전형적인 여행 호스텔 환경에서 다른\n사람들과 함께 하세요. 8개의 침대가 있는 방으로, 혼자 여행하시면서 익숙해지신 '공간 좀 주세요'\n와 '이야기할 시간이에요'의 미묘한 균형을 제공합니다.\n</p>",
  'camp67-contact.campsite-address': '캠프장 주소',
  'camp67-contact.helpdesk': '도움말 번호',
  'camp67-contact.whatsapp-only': 'WhatsApp 메시지 전용',
  'camp67-contact.outside-india': '인도 외부에서',
  'camp67-contact.map': '지도에서 보기',
  'camp67-tent-amenity.comfortable-living.side-table-glasses':
    '일회용 유리잔이 있는 사이드 테이블',
  'camp67-tent-amenity.comfortable-living.side-table': '사이드 테이블',
  'camp67-tent-amenity.toiletries.bath-towel-single': '감차 (얇은 면 수건)',
  'camp67-tent-amenity.power-storage.electric-power-point-2x-s': '2배 전원 콘센트',
  'camp67-tent-amenity.food-beverage.lemongrass-tea': 'Sukrit 레몬그라스 차',
  'camp67-navigation.kumbh-2025.sacred-gathering-of-magh-mela': '막 메라: 신성한 모임',
  'significance-of-magh.subtitle': '마그의 신성한 모임.',
  'significance-of-magh.hero-image-alt':
    '마그 멜라 동안 트리베니 상감에서 성스러운 목욕을 하고 있는 신자들.',
  'significance-of-magh.summary':
    '마그 멜라는 매년 마그(1월~2월)의 길조로운 힌두 달에 열리며, 신성한 강둑에서 신자들이 목욕하고 명상하며 영적 향상을 추구하는 오랜 전통의 모임입니다.',
  'significance-of-magh.content':
    '\n    <p>\n      마그 멜라는 더 작지만 마찬가지로 심오한 쿰브의 작은 형제로 종종 간주되며,\n      프라야그라지의 갠지스, 야무나 및 신비로운 사라스와티 강의 신성한 합류점에서 매년\n      축하됩니다.\n    </p>\n    <paragraph>\n      고대 전통에 뿌리를 두고, 마그의 달은 영적 수행에 대해 매우 길조로운 것으로 간주되었습니다.\n      힌두 경전, 예를 들어 푸라나스는 이 기간 동안 특히 트리베니 상감에서 신성한 강에서 목욕하는 것이\n      죄를 씻어내고 해탈(목샤)의 길을 열어준다고 강조합니다.\n    </paragraph>\n    <paragraph>\n      마그 멜라는 단순히 목욕의 의식이 아니라 성인, 현자, 수행자 및 평신도들이 함께 모여\n      참회의식을 행하고 구절을 낭송하며 신앙심에 몰두하는 신성한 집회입니다.\n      많은 사람들이 칼파바스를 수행하는데, 이는 전체 마그 기간 동안 강둑 근처에 머물며 기도,\n      명상, 봉사만을 수행하는 단순함의 서원을 말합니다.\n    </paragraph>\n    <paragraph>\n      멜라는 신앙의 시간적 연속성과 우주의 순환 리듬을 상징하며, 유한과 무한의 결합을\n      상기시켜 줍니다. 강들이 상감에서 만나는 것처럼 마그 멜라는 진리 추구에서\n      신체, 마음, 영혼의 융합을 나타냅니다.\n    </paragraph>\n    <paragraph>\n      상징적으로 강들은 인간 의식의 채널을 나타내고, 그들의 합류는 지식, 헌신, 행동의\n      자기 내적 통합을 상징합니다. 따라서 마그 멜라는 개인이 내적 존재를 정화하고\n      새로운 명확성을 가지고 다르마의 길을 걷도록 영감을 줍니다.\n    </paragraph>\n  ',
  'camp67-inquiry.event-badge': 'Magh Mela 2026 • 1월 3일 - 2월 18일',
  'camp67-inquiry.hero-subtitle':
    '성스러운 합류 지점의 중심에서 현대적인 편의시설을 갖춘 프리미엄 텐트 숙소',
  'camp67-inquiry.express-interest': '관심 표시',
  'camp67-inquiry.express-your-interest': '관심을 표시하세요',
  'camp67-inquiry.modal-title': '관심 표시',
  'camp67-inquiry.modal-subtitle': 'Magh Mela 2026 • 1월 3일 - 2월 18일',
  'camp67-inquiry.accommodation-preference': '숙소 선호',
  'camp67-inquiry.no-preference': '선호 없음',
  'camp67-inquiry.twin-cottage': '트윈 침대 코티지',
  'camp67-inquiry.premium-cottage': '프리미엄 코티지',
  'camp67-inquiry.family-cottage': '패밀리 코티지',
  'camp67-inquiry.private-group': '프라이빗 그룹 코티지',
  'camp67-inquiry.dorm-single': '도미토리 싱글 침대',
  'camp67-inquiry.dorm-bunk': '도미토리 2층 침대',
  'camp67-inquiry.checkin': '체크인',
  'camp67-inquiry.checkout': '체크아웃',
  'camp67-inquiry.checkin-date': '체크인 날짜',
  'camp67-inquiry.checkout-date': '체크아웃 날짜',
  'camp67-inquiry.guests': '인원',
  'camp67-inquiry.number-of-guests': '인원 수',
  'camp67-inquiry.how-many': '몇 명인가요?',
  'camp67-inquiry.guest-singular': '명',
  'camp67-inquiry.guest-plural': '명',
  'camp67-inquiry.guests-10-plus': '10명 이상',
  'camp67-inquiry.contact-details': '연락처 정보',
  'camp67-inquiry.full-name': '성함',
  'camp67-inquiry.email': '이메일',
  'camp67-inquiry.phone': '전화번호',
  'camp67-inquiry.your-name': '이름을 입력하세요',
  'camp67-inquiry.email-placeholder': 'you@example.com',
  'camp67-inquiry.phone-placeholder': '+91 XXXXX XXXXX',
  'camp67-inquiry.additional-message': '추가 메시지 (선택)',
  'camp67-inquiry.message-placeholder': '특별 요청이나 질문이 있나요?',
  'camp67-inquiry.required-fields-error': '* 표시된 필수 항목을 모두 입력해 주세요',
  'camp67-inquiry.submit-interest': '관심 제출',
  'camp67-inquiry.submitting': '제출 중...',
  'camp67-inquiry.thank-you': '감사합니다!',
  'camp67-inquiry.success-message':
    '관심 접수가 완료되었습니다. 12시간 이내에 예약 가능 여부와 다음 단계에 대해 연락드리겠습니다.',
  'camp67-inquiry.close': '닫기',
  'camp67-inquiry.secure-info': '🔒 귀하의 정보는 안전하게 보호됩니다.',
  'camp67-inquiry.ready-to-experience': 'Magh Mela 2026을 경험할 준비가 되셨나요?',
  'camp67-inquiry.interest-in': '관심 표시:',
  'camp67-we-love-kumbh.full-heading':
    '우리는 Kumbh를 알고 <love-highlight>사랑</love-highlight>합니다',
  'camp67-reservation.form.step': '단계',
  'camp67-reservation.form.step.continue': '계속',
  'camp67-reservation.form.step.reset': '초기화',
  'camp67-reservation.form.step-1.price-per-night': '/박',
  'camp67-reservation.form.step-1.meals-included': '식사 포함',
  'camp67-reservation.form.step-1.private-bathroom': '개인 욕실',
  'camp67-reservation.form.step-1.shared-bathroom': '공용 욕실',
  'camp67-reservation.form.step-2.check-in': '체크인 날짜',
  'camp67-reservation.form.step-2.check-out': '체크아웃 날짜',
  'camp67-reservation.form.step-3.guests.enter-gender': '성별을 선택하세요...',
  'camp67-reservation.form.submit.continue': '계속',
  'camp67-reservation.payment.pay-with': '다음으로 결제',
  'camp67-reservation.payment.disabled': '먼저 서비스 이용약관에 동의해 주세요.',
  'camp67-reservation.payment.paypal.title': 'PayPal에서 완료',
  'camp67-reservation.payment.paypal.nearly-there': '거의 다 됐습니다!',
  'camp67-reservation.payment.paypal.instructions':
    '결제를 완료하려면 아래에서 PayPal에 정보를 입력해 주세요. 완료되면 다시 이곳으로 돌아오도록 리디렉션됩니다.',
  'camp67-reservation.payment.error.title': '문제가 발생했습니다',
  'camp67-reservation.payment.error.description':
    '결제를 처리할 수 없습니다. 다시 시도해 주세요.',
  'camp67-reservation.payment.error.contact-support': '지원팀에 문의',
  'camp67-accommodation.starting-from': '시작가',
  'camp67-accommodation.per-night': '1박당',
  'camp67-accommodation.capacity': '수용 인원',
  'camp67-accommodation.guest': '게스트',
  'camp67-accommodation.guests': '게스트',
  'camp67-accommodation.gallery': '갤러리',
  'camp67-accommodation.about': '이 숙소 소개',
  'camp67-accommodation.whats-included': '포함 사항',
  'camp67-accommodation.ready-cta-title': 'Mahakumbh를 경험할 준비가 되셨나요?',
  'camp67-accommodation.ready-cta-description':
    'Magh Mela 2026를 위해 지금 예약하고 자리를 확보하세요.',
};
